/* global store */
/* global IS_PREVIEW_PAGE TP_TRACKING */

import { setScrollerScreenHeight } from 'Renderer/actions/adActions';
import { visibilityChangeEvent } from 'Renderer/domOperations/adOperations';
import { isNestedIframe, getNestedWindow } from 'Renderer/domOperations/iFrameOperations';
const scrollerWindow = isNestedIframe() ? getNestedWindow() : window;

const resizePreviewContainer = (adjustedViewport) => {
  document.body.style.overflow = 'scroll';
  document.body.style.height = `calc(110vh + ${(adjustedViewport.height) * 3}px)`;
};

const setElementWidth = (element, width) => {
  const elemWidth = isNaN(width) ? width : `${width}px`;
  element.style.setProperty('width', elemWidth, 'important');
};

const setElementHeight = (element, height) => {
  const elemHeight = isNaN(height) ? height : `${height}px`;
  element.style.setProperty('height', elemHeight, 'important');
};

export const resizeScrollerContainer = () => {
  const { rootElement, activeArtboard, canAccessIframe } = store.getState();
  const scrollerContainer = canAccessIframe ? scrollerWindow.frameElement.parentNode : rootElement;
  const artboardWidth = activeArtboard.viewport.width;
  const adjustablePercentage = (scrollerContainer.clientWidth / artboardWidth);
  const adjustedViewportHeight = parseInt(activeArtboard.viewport.height * adjustablePercentage, 10);
  const adjustedDimensionsWidth = parseInt(activeArtboard.dimensions.width * adjustablePercentage, 10);
  const adjustedDimensionsHeight = parseInt(activeArtboard.dimensions.height * adjustablePercentage, 10);
  const adjustedDimensions = { width: adjustedDimensionsWidth, height: adjustedDimensionsHeight };

  if (IS_PREVIEW_PAGE && !frameElement) resizePreviewContainer(adjustedDimensions);

  if (canAccessIframe) {
    const iframeParent = scrollerWindow.frameElement.parentNode;
    setElementHeight(iframeParent, adjustedViewportHeight);
    setElementHeight(scrollerWindow.frameElement, adjustedDimensionsHeight);
    if (isNestedIframe()) {
      setElementHeight(frameElement, adjustedViewportHeight);
      setElementHeight(frameElement.parentNode, adjustedDimensionsHeight);
    }
    if (!IS_PREVIEW_PAGE) {
      setElementWidth(frameElement, adjustedDimensionsWidth);
      if (scrollerWindow.frameElement.parentNode.offsetHeight < 350) setElementHeight(scrollerWindow.frameElement.parentNode, `${adjustedViewportHeight}px`);
      if (scrollerWindow.frameElement.parentNode.parentNode.offsetHeight < 350) setElementHeight(scrollerWindow.frameElement.parentNode.parentNode, `${adjustedViewportHeight}px`);
    }
    const scrollerScreenHeight = frameElement.getAttribute('data-ivo-geom');
    if (scrollerScreenHeight) setScrollerScreenHeight(scrollerScreenHeight);
  } else {
    setElementHeight(rootElement.parentNode.parentNode.parentNode, adjustedViewportHeight);
    setElementHeight(rootElement.parentNode.parentNode.parentNode.parentNode, adjustedViewportHeight);
    setElementHeight(rootElement.parentNode.parentNode, adjustedDimensionsHeight);
    setElementHeight(rootElement.parentNode, adjustedDimensionsHeight);
    setElementHeight(rootElement, adjustedDimensionsHeight);
  }
  visibilityChangeEvent();
};

export const resetScrollerAdContainer = () => {
  const { activeArtboard, canAccessIframe } = store.getState();
  if (canAccessIframe) {
    const adContainer = frameElement;
    const resetRequired = (adContainer.offsetWidth !== adContainer.parentNode.offsetWidth);
    if (resetRequired) {
      adContainer.style.width = 'inherit';
      if (activeArtboard) resizeScrollerContainer();
    }
  }
};


export const initScrollerContainer = (tagInformation, canAccessIframe) => {
  const rootElement = canAccessIframe ? scrollerWindow.frameElement : tagInformation.element;
  const rootWindow = canAccessIframe ? window.top : window;
  try {
    const adParent = rootElement.parentNode;
    const tagElement = tagInformation.element;
    let element = tagElement;

    while (element.parentNode.nodeName !== 'HTML') {
      element.style.width = '100%';
      element.style.height = '100%';
      element.style.maxWidth = '100%';
      element.style.maxHeight = '100%';
      element = element.parentNode;
    }

    adParent.style.webkitClipPath = 'inset(0px)';
    adParent.style.clipPath = 'inset(0px)';
    adParent.style.clip = 'rect(0px, auto, auto, 0px)';
    adParent.style.top = '0';
    adParent.style.setProperty('text-align', 'left', 'important');
    adParent.style.width = 'inherit';
    adParent.style.minWidth = '100%';
    adParent.style.height = '250px';
    adParent.style.maxHeight = 'none';
    adParent.parentNode.style.width = 'inherit';
    if (isNestedIframe()) {
      rootElement.style.width = '100%';
      rootElement.style.minWidth = '100%';
      frameElement.style.width = '100%';
      frameElement.parentNode.style.width = '100%';
    }
    if (!IS_PREVIEW_PAGE) {
      adParent.parentNode.parentNode.style.width = '100%';
      adParent.parentNode.style.width = '100%';
      adParent.parentNode.style.maxwidth = '100%';
      adParent.parentNode.style.maxHeight = 'none';
      adParent.parentNode.style.minHeight = 'auto';
      adParent.parentNode.style.height = 'auto';
      tagElement.parentNode.style.width = '100%';
      tagElement.parentNode.style.height = '100%';
    }
    rootElement.style.position = 'fixed';
    rootWindow.addEventListener('resize', resetScrollerAdContainer);
  } catch (e) {
    console.log('ivo : error rendering Scroller container');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/scrollerContainer.js